import pattern from "../../../images/pattern-taxation.png";
import styled from "styled-components";
import styles from "./styles.module.css";
import { useEffect, useRef, useState } from "react";

const StyledContainerChat = styled.div`
  width: 100%;
  height: ${(prop) => (prop.open ? "300px" : "0px")};
  background-image: url(${pattern});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 8px;
  transition: all 0.3s ease;
  transform-origin: top;
`;

const StyledModuleMsg = styled.div`
  align-self: flex-start;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  min-height: 2.5rem;
  border-radius: 8px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
  max-width: 35rem;
  padding: 5px;
  gap: 5px;
  position: relative;

  ${(props) =>
    props.content &&
    `
    &::before {
      background-color: #fff;
      content: "${props.content}";
      position: absolute;
      opacity: 0;
      padding: 5px;
      border-radius: 5px;
      bottom: -35px;
      white-space: nowrap;
      transition: all 0.5s ease;
      font-weight: 300;
      font-size: 12px;
    }

    &:hover::before {
      opacity: 1;
    }
  `}
`;
const MsgModule = ({ msg, date, tipoContato, tipoUsuario, nome }) => {
  const [stylesClass, setStylesClass] = useState({
    container: "",
    dateSpan: "",
  });
  const convertDate = (dateString) => {
    const data = new Date(dateString);

    const dataFormatada = data.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    const horarioFormatado = data.toLocaleTimeString("pt-BR", {
      hour: "2-digit",
      minute: "2-digit",
    });

    return `${dataFormatada} - ${horarioFormatado}`;
  };

  const setView = () => {
    const baseClass = styles.main__container;

    if (tipoUsuario === "I") {
      setStylesClass({
        ...stylesClass,
        container: `${baseClass} ${
          tipoContato === "usuario_interno" ? styles.right : ""
        }`,
        dateSpan: `${styles.dateText__moduleMsg} ${
          tipoContato === "usuario_externo"
            ? styles.dateText__moduleMsg_rigth
            : ""
        }`,
      });
    } else {
      setStylesClass({
        ...stylesClass,
        container: `${baseClass} ${
          tipoContato === "usuario_externo" ? styles.right : ""
        }`,
        dateSpan: `${styles.dateText__moduleMsg} ${
          tipoContato === "usuario_externo"
            ? styles.dateText__moduleMsg_rigth
            : ""
        }`,
      });
    }
  };

  useEffect(() => {
    setView();
  }, []);

  return (
    <div className={stylesClass.container}>
      <span className={styles.topic__module}></span>

      <StyledModuleMsg content={tipoUsuario === "I" ? nome : null}>
        <p>{msg}</p>
        <p className={stylesClass.dateSpan}>{convertDate(date)}</p>
      </StyledModuleMsg>
    </div>
  );
};

const UiChat = ({ data, infoText, tipoUsuario }) => {
  const lastMessageRef = useRef(null);

  useEffect(() => {
    if (lastMessageRef.current) {
      lastMessageRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [data]);

  return (
    <>
      {data.length > 0 && tipoUsuario ? (
        <StyledContainerChat open={data.length > 0}>
          <div className={styles.infoText__container}>
            <p>{infoText}</p>
          </div>
          <div className={styles.msgs__container}>
            {data.map((item, index) => (
              <div
                key={index}
                ref={index === data.length - 1 ? lastMessageRef : null}
                className={styles.msg}
              >
                <MsgModule
                  key={index}
                  msg={item.msg}
                  date={item.createdAt}
                  tipoContato={item.tipoContato}
                  tipoUsuario={tipoUsuario}
                  nome={item.nome.split(" ")[0]}
                />
              </div>
            ))}
          </div>
        </StyledContainerChat>
      ) : (
        <p>Não há mensagens aqui ainda</p>
      )}
    </>
  );
};

export default UiChat;
